export default "__VITE_ASSET__MAMehHAE__ 584w";